export const profile = {
  name: 'Jean Pierre Lefranc',
  fullName: 'Jean Pierre Lefranc Hernández',
  photo: 'https://cdn.magicpatterns.com/uploads/waLpu2vbP1SRsXXaxMLfe8/Foto_JPL.jpg',
  location: 'Santiago, Santiago Metropolitan Region, Chile',
  headline: [
    'Regional Technology Executive',
    'Digital Transformation & AI',
    'Former CIO',
    'Board Chairman',
    'Regional Operations & Commercial Growth',
    'Strategic Advisor',
    'Latin America',
  ],
  intro:
    'Senior executive in the technology industry with a career spanning IT direction, digital transformation, strategic business consultancy, solutions selling, channel development and marketing. He has led teams, markets and transformation programs across South America.',
  email: 'jean.lefranc@vtr.net',
  phone: '+569 3242 8909',
  phoneHref: 'tel:+56932428909',
  linkedin: 'www.linkedin.com/in/jplefranc',
  linkedinHref: 'https://www.linkedin.com/in/jplefranc',
};

export const heroFacts = [
  { label: 'Chief Information Officer', detail: 'Megalabs Chile, 2017–2022' },
  { label: 'Chairman of the Board', detail: 'Provectis, 2023–2025' },
  { label: 'Market Development & Sales', detail: 'Intel Corporation, 2005–2016' },
  { label: 'MBA', detail: 'Universidad Adolfo Ibáñez' },
];

export const aboutParagraphs = [
  'Senior executive with more than 20 years of experience in management, strategic business development, sales, channel development and marketing. He has worked for multinational companies in the technology industry in IT direction, strategic business consultancy, solutions selling, IT services, consumer electronics and IT infrastructure.',
  'He has led IT areas, digital transformation processes, strategic sales management, business planning, channel development, product management and marketing across South America: Argentina, Chile, Peru, Colombia, Ecuador and Bolivia.',
  'Focused on results, with long-term vision and excellent communication skills. Customer- and teamwork-oriented, and highly adaptable to multicultural environments.',
];

export const specialties = [
  'IT Management',
  'Team Leadership',
  'Channel Development',
  'Strategic Business Development',
  'Sales & Customer Management',
  'Product Management',
  'Marketing',
  'Latin America Region Knowledge',
];

export const industries = [
  'IT direction & IT services',
  'Consumer electronics & IT infrastructure',
  'Enterprise software, BI & ERP',
  'Pharmaceuticals & logistics',
  'Cybersecurity & infrastructure monitoring',
  'Utilities, health institutions & pension funds',
  'Financial & insurance sectors',
];

export const glance = {
  primary: { value: '1984', label: 'Career in technology and business since 1984' },
  secondary: [
    { value: '6', label: 'South American countries in regional leadership' },
    { value: '10+ yrs', label: 'At Intel Corporation' },
    { value: '10', label: 'Organizations' },
  ],
};
